import { render, staticRenderFns } from "./confiGu.vue?vue&type=template&id=176311fe&scoped=true&"
import script from "./confiGu.vue?vue&type=script&lang=js&"
export * from "./confiGu.vue?vue&type=script&lang=js&"
import style0 from "./confiGu.vue?vue&type=style&index=0&id=176311fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176311fe",
  null
  
)

export default component.exports